__turbopack_context__.v({
  "buttonRow": "FiltersDrawer-module__BsecJW__buttonRow",
  "drawer": "FiltersDrawer-module__BsecJW__drawer",
  "drawerTitle": "FiltersDrawer-module__BsecJW__drawerTitle",
  "filtersPanel": "FiltersDrawer-module__BsecJW__filtersPanel",
});
